import { Box, Typography } from '@mui/material'

import RubricPointsChip from '../Rubric/RubricPointsChip'

export default function RubricCard({ onClick, name, description, total_points = 0 }) {
  return (
    <Box
      sx={{
        p: '8px 16px',
        bgcolor: '#F2F4F7',
        border: '1px solid #D0D5DD',
        cursor: 'pointer',
        '&:hover': {
          bgcolor: '#E5E8EB',
        },
        borderRadius: '16px',
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          display: 'flex',
          gap: '8px',
        }}
      >
        <Box
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '100%',
          }}
        >
          <Typography
            gutterBottom
            fontSize={14}
            fontWeight={500}
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {name}
          </Typography>
        </Box>
      </Box>
      <Typography
        color="#667085"
        fontSize={12}
        fontWeight={400}
        sx={{
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}
      >
        {description}
      </Typography>
      <Box mt="8px">
        <RubricPointsChip points={total_points} title="" />
      </Box>
    </Box>
  )
}
